import { z } from 'zod';
import {
  isAddressValid,
  isAtLeastAge,
  isBirthdayValid,
  isCityValid,
  isEmptyString,
  isNameValid,
  isPhoneNumberValid,
  isZipcodeValid,
} from './validation';

const VALIDATION_ERRORS = {
  FIELD_EMPTY: 'Required field',
  INVALID_INPUT: 'Invalid input',
  INVALID_DATE: 'Invalid date',
  INVALID_AGE: 'Must be at least 13 years old',
};

const requiredString = z
  .string()
  .min(1, { message: VALIDATION_ERRORS.FIELD_EMPTY });

const requiredStreetAddress = requiredString.refine(isAddressValid, {
  message: VALIDATION_ERRORS.INVALID_INPUT,
});

const optionalStreetAddress = z
  .string()
  .optional()
  .refine((value) => isEmptyString(value) || isAddressValid(value), {
    message: VALIDATION_ERRORS.INVALID_INPUT,
  });

const requiredAddress = z.object({
  addressLine1: requiredStreetAddress,
  addressLine2: optionalStreetAddress,
  city: requiredString.refine((value) => (value ? isCityValid(value) : true), {
    message: VALIDATION_ERRORS.INVALID_INPUT,
  }),
  state: requiredString,
  zipCode: requiredString.refine(isZipcodeValid, {
    message: VALIDATION_ERRORS.INVALID_INPUT,
  }),
});

export const schema = z.object({
  firstName: requiredString.refine(isNameValid),
  lastName: requiredString.refine(isNameValid),
  phoneNumber: requiredString.refine(
    (value) => {
      const phone = value.replace(/\D+/g, ''); // Remove extra chars from Phone
      return isPhoneNumberValid(phone.slice(1));
    },
    {
      message: VALIDATION_ERRORS.INVALID_INPUT,
    },
  ),
  mailingAddress: requiredAddress,
  dateOfBirth: requiredString
    .refine(isBirthdayValid, {
      message: VALIDATION_ERRORS.INVALID_DATE,
    })
    .refine(isAtLeastAge, {
      message: VALIDATION_ERRORS.INVALID_AGE,
    }),
});

export type BasicInfoFormSchema = z.infer<typeof schema>;
